module.exports = __webpack_public_path__ + "static/media/project3.7728ff54.png";